import { useEffect, useState } from 'react';

/**
 * HeroLoop — the hero background video for the premium marketing pages
 * (HomePage `/` and ProPage `/pro`).
 *
 * Serves the 9:16 portrait loop (`hero-loop-portrait`) on phones and the
 * 16:9 landscape loop (`hero-loop`) on larger screens, so the mobile hero
 * is a purpose-framed vertical shot rather than a hard centre-crop of a
 * wide video. The `key` forces a remount when the orientation bucket
 * flips so the new <source> set is picked up; only the matching video is
 * ever in the DOM, so the other file isn't fetched.
 *
 * Poster is the shared landscape still (there's no portrait poster asset);
 * it only shows for the sub-second before autoplay begins and sits on the
 * navy hero ground, so the crop is unnoticeable.
 */
const PORTRAIT_QUERY = '(max-width: 940px)';

export default function HeroLoop() {
  const [portrait, setPortrait] = useState(
    () =>
      typeof window !== 'undefined' &&
      !!window.matchMedia?.(PORTRAIT_QUERY).matches,
  );

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mq = window.matchMedia(PORTRAIT_QUERY);
    const onChange = () => setPortrait(mq.matches);
    onChange();
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  const base = portrait
    ? '/marketing/hero-loop-portrait'
    : '/marketing/hero-loop';

  return (
    <video
      key={base}
      className="media-cover"
      autoPlay
      muted
      loop
      playsInline
      poster="/marketing/hero-poster.jpg"
    >
      <source src={`${base}.webm`} type="video/webm" />
      <source src={`${base}.mp4`} type="video/mp4" />
    </video>
  );
}
